import { render, staticRenderFns } from "./ProcessFBMReportTable.vue?vue&type=template&id=36e584f6&scoped=true"
import script from "./ProcessFBMReportTable.vue?vue&type=script&lang=js"
export * from "./ProcessFBMReportTable.vue?vue&type=script&lang=js"
import style0 from "./ProcessFBMReportTable.vue?vue&type=style&index=0&id=36e584f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e584f6",
  null
  
)

export default component.exports